import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=52e23a89&scoped=true"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"
import style0 from "./ItemForm.vue?vue&type=style&index=0&id=52e23a89&prod&scoped=true&lang=css"
import style1 from "./ItemForm.vue?vue&type=style&index=1&id=52e23a89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e23a89",
  null
  
)

export default component.exports